import {FC, memo} from 'react'
import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {contractSelector, setCustomerFilter} from '../../../redux/slices/contractSlices'
import Pagination from '../component/Pagination'

interface TableBrowseCustomerProps {
  customerList: any[]
  paginateNumber: any
  numberURL: any
  onSelectCustomer: (value: any) => void
}

// eslint-disable-next-line react/display-name
export const TableBrowseCustomer = memo((props: TableBrowseCustomerProps) => {
  const {t} = useTranslation()
  const {customerList, numberURL, paginateNumber, onSelectCustomer} = props
  const {customerFilter: filter} = useAppSelector(contractSelector)
  const dispatch = useAppDispatch()

  return (
    <div className='table-responsive bdr'>
      <table className='table'>
        <thead>
          <tr className='d-flex jusify-content-center w-100 align-items-center'>
            <th className='td-order-11 text-center'></th>
            <th className='td-order-4 text-center'>{t('Customer Code')}</th>
            <th className='td-order-4 text-center'>{t('Customer Name')}</th>
          </tr>
        </thead>
        <tbody>
          <tr className='d-flex jusify-content-center w-100 align-items-center'>
            <td className='td-order-11 text-center'>
              <div className='text-transparent' style={{padding: '.42rem 0'}}>
                -
              </div>
            </td>
            <td className='td-order-4 text-center pm-0'>
              <TextInputV2
                placeholder={t('Customer Code')}
                style={{padding: '8px 0', border: 0}}
                value={filter?.customer_code ?? ''}
                onChange={({target}) =>
                  dispatch(setCustomerFilter({...filter, customer_code: target.value}))
                }
              />
            </td>
            <td className='td-order-4 text-center pm-0'>
              <TextInputV2
                placeholder={t('Customer Name')}
                style={{padding: '8px 0', border: 0}}
                value={filter?.name ?? ''}
                onChange={({target}) =>
                  dispatch(setCustomerFilter({...filter, name: target.value}))
                }
              />
            </td>
          </tr>
          {customerList?.map((item: any, index: number) => {
            return (
              <tr
                key={item?.customer_code ?? index}
                className={`d-flex jusify-content-center w-100 align-items-center ${
                  index % 2 === 0 && 'bg-secondary'
                }`}
              >
                <td className='td-order-11 text-center checkk'>
                  <Form.Check
                    reverse
                    type='checkbox'
                    id={item?.customer_code}
                    onChange={() => onSelectCustomer(item)}
                  />
                </td>
                <td className='td-order-4 text-center'>
                  <span className='d-block' style={{padding: '.08rem 0'}}>
                    {item.customer_code}
                  </span>
                </td>
                <td className='td-order-4 text-center'>
                  <span className='d-block' style={{padding: '.08rem 0'}}>
                    {item.name}
                  </span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className='my-5'>
        <Pagination paginate={paginateNumber} test={numberURL} />
      </div>
    </div>
  )
})
